'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

var _FAIcon = require('./../icon/FAIcon');

var _FAIcon2 = _interopRequireDefault(_FAIcon);

var _SearchField = require('./SearchField');

var _SearchField2 = _interopRequireDefault(_SearchField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Hledací field s 2 režimy, první obdobný jako SearchField (komopnenta je pouze obal pro SearchField druhý je pro čtečku čárových kódů, přepíná se tlačítkem s čárovým kódem.
 * Čtečka simuluje klávesnici
 */
var CteckaField = function (_AbstractField) {
    (0, _inherits3.default)(CteckaField, _AbstractField);

    function CteckaField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CteckaField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CteckaField.__proto__ || (0, _getPrototypeOf2.default)(CteckaField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            cteckaMode: false
        }, _this.handleModeSwitch = function () {
            _this.setState(function (prevState) {
                return {
                    cteckaMode: !prevState.cteckaMode
                };
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CteckaField, [{
        key: 'render',
        value: function render() {
            var cteckaMode = this.state.cteckaMode;
            var _props = this.props,
                searchOnChange = _props.searchOnChange,
                disabled = _props.disabled,
                props = (0, _objectWithoutProperties3.default)(_props, ['searchOnChange', 'disabled']);


            var cteckaButtonColor = cteckaMode ? "primary" : "secondary";

            return _react2.default.createElement(_SearchField2.default, (0, _extends3.default)({}, props, {
                disabled: disabled,
                searchOnChange: cteckaMode || searchOnChange,
                customButton: _react2.default.createElement(
                    _reactstrap.Button,
                    { color: cteckaButtonColor,
                        disabled: disabled,
                        onClick: this.handleModeSwitch,
                        type: 'button' },
                    _react2.default.createElement(_FAIcon2.default, {
                        icon: 'barcode' })
                )
            }));
        }
    }]);
    return CteckaField;
}(_AbstractField3.default);

CteckaField.PropTypes = {
    debounceTime: _react2.default.PropTypes.number,
    searchOnChange: _react2.default.PropTypes.bool // pokud je true, hledá se hned při psaní se spožděním debounceTime, pokud je false, hledá se při stisku hledat nebo enter
};
CteckaField.defaultProps = {
    debounceTime: 250,
    searchOnChange: false
};
exports.default = CteckaField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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